import {
  I18N_AVANT_PROPERTY_ATTR_PATH,
  I18N_AVANT_PROPERTY_LABEL_PATH,
} from 'constants/i18n';

export const I18N_SALE_LABEL_PATH = `${I18N_AVANT_PROPERTY_LABEL_PATH}.sales`;
export const I18N_PLATFORM_SALE_PATH = `${I18N_AVANT_PROPERTY_ATTR_PATH}.sale`;
